export const getCssLegend = (carparkName, productName) => {
  let legend = "direct" // weparkyoufly standard standardplus budget
  switch (carparkName) {
    case "P4":
    case "P4 S":
    case "P7":
    case "P7a":
    case "P7b":
    case "P8":
      legend = "direct"
      break
    case "P6":
      if (productName === "We Park You Fly") legend = "weparkyoufly"
      else legend = "direct"
      break

    case "P5":
    case "P9":
    case "P10":
      legend = "standardplus"
      break
    case "P1":
    case "P3":
    case "P11":
    case "P12":
      legend = "standard"
      break
    case "P15":
    case "P17":
    case "P19":
      legend = "budget"
      break
    default:
      legend = ""
  }
  return legend
}

export const getCategoryName = (carparkName, productName) => {
  let categoryName = "Direct" // weparkyoufly standard standardplus budget
  switch (carparkName) {
    case "P4":
    case "P4 S":
    case "P7":
    case "P7a":
    case "P7b":
    case "P8":
      categoryName = "Direct"
      break
    case "P6":
      if (productName === "We Park You Fly") categoryName = "We Park You Fly"
      else categoryName = "Direct"
      break

    case "P5":
    case "P9":
    case "P10":
      categoryName = "Standard+"
      break
    case "P1":
    case "P3":
    case "P11":
    case "P12":
      categoryName = "Standard"
      break
    case "P15":
    case "P17":
    case "P19":
      categoryName = "Budget"
      break
    default:
      categoryName = ""
  }
  return categoryName
}

export const getContentEnrichedProduct = (resultProduct, content) => {
  return {
    //typeText: this.getContentData(resultProduct.carPark.name, resultProduct.product, content).typeText,
    image: null,
    id: resultProduct.product.id,
    name: resultProduct.product.name,
    location: resultProduct.carPark.name,
    noOriginalPrice: resultProduct.result.barrierTariff === 0,
    carPark: resultProduct.carPark,
    product: resultProduct.product,
    result: resultProduct.result,
    price: resultProduct.result.totalPrice,
    originalPrice: resultProduct.result.barrierTariff,
    ...getContentData(resultProduct.carPark, resultProduct.product, content),
  }
}

export const getCategoryIcon = (lotCode) => {
  switch (lotCode) {
    case "direct":
    case "standardplus":
    case "standard":
      return "/static/parkingproductimage-02.svg"
    case "weparkyoufly":
      return "/static/parkingproductimage-03.svg"
    case "budget":
      return "/static/parkingproductimage-01.svg"
    default:
      return null
  }
}

export const getContentData = (carPark, product, content) => {
  const lotCode = getCssLegend(carPark.name, product.name)
  const contentProduct = {
    lotCode: lotCode,
    type: lotCode,
    icon: getCategoryIcon(lotCode),
  }

  if (content && content.parkingProducts && content.parkingProducts[lotCode]) {
    contentProduct.description = content.parkingProducts[lotCode].description
    contentProduct.typeText = content.parkingProducts[lotCode].typeText
    contentProduct.usp = content.parkingProducts[lotCode].usp
    contentProduct.resume = content.parkingProducts[lotCode].resume
    contentProduct.bodySections = content.parkingProducts[lotCode].bodySections
    contentProduct.flowText = content.parkingProducts[lotCode].flowText
    contentProduct.flowImage = content.parkingProducts[lotCode].flowImage
    contentProduct.upgradeText = content.parkingProducts[lotCode].upgradeText
  }
  if (content && content.carParks && content.carParks[carPark.name]) {
    contentProduct.carParkResume = content.carParks[carPark.name].parkingDetailsModalResume
    contentProduct.carParkUsp = content.carParks[carPark.name].usp
  }
  return contentProduct
}

export const getParkingProductUpgradeText = (carPark, product, content) => {
  const lotCode = getCssLegend(carPark.name, product.name)

  if (content && content.parkingProducts && content.parkingProducts[lotCode]) {
    return content.parkingProducts[lotCode].upgradeText
  }
}

export const getCarParkContentData = (carPark, product, content) => {
  const lotCode = getCssLegend(carPark.name, product.name)
  const carParkName = carPark.name
  const carParkContent = {
    lotCode: lotCode,
    type: lotCode,
    icon: getCategoryIcon(lotCode),
  }

  if (content && content.carParks && content.carParks[carParkName]) {
    carParkContent.textualGuide = {
      headline: content.carParks[carParkName].textualGuide.textualGuideHeadline,
      body: content.carParks[carParkName].textualGuide.textualGuideBody,
    }
    carParkContent.geoLocation = {
      x: content.carParks[carParkName].geoLocation.x,
      y: content.carParks[carParkName].geoLocation.y,
    }
  }

  return carParkContent
}

export const getIdentifiedCampaignFlag = (cfProduct, newProduct) => {
  const standardProducts = [
    "S-Standard-P1",
    "S-Standard-P3",
    "S-Standard-P5",
    "S-Standard-P6",
    "S-Standard-P9",
    "S-Standard-P11",
    "S-Standard-P10",
    "S-Standard-P1Old",
    "S-Standard-P12",
    "S-Weekend-P1",
    "S-Weekend-P5",
    "S-Weekend-P9",
    "S-Weekend-P10",
    "S-Weekend-P11",
    "S-Weekend-P12",

    "D-Direct-P4",
    "D-Direct-P6",
    "D-Direct-P7",
    "D-Direct-P7a",
    "D-Direct-P7b",
    "D-Direct-P8",
    "D-Weekend-P4",
    "D-Weekend-P6",
    "D-Weekend-P7",
    "D-Weekend-P7a",
    "D-Weekend-P7b",
    "D-Weekend-P8",

    "B-Budget-P15",
    "B-Budget-P17",
    "B-Budget360-P19",
    "W-WePark-P6",
    "W-WePark1-P6",
    "W-WePark2-P6",
  ]
  let newBookingIsCampaign = !standardProducts.includes(newProduct.code)
  let changeFromBookingIsCampaign = !standardProducts.includes(cfProduct.code)
  let showCampagneNotAvailableBox = false

  if (changeFromBookingIsCampaign) {
    if (!newBookingIsCampaign) {
      showCampagneNotAvailableBox = true
    }
  }

  return showCampagneNotAvailableBox
}
